import { _post, _get, _delete } from "./Axios";

export default class RealisasiKpiApi {
  static get(id = null) {
    if (id == null) {
      return _get("kpi/realisation/");
    } else {
      return _get("kpi/realisation/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/realisation/?" + params);
  }
  static post(data) {
    return _post("kpi/realisation/", data);
  }
  static update(id, data) {
    return _post("kpi/realisation/" + id, data);
  }
  static changePassword(id, data) {
    return _post("kpi/realisation/" + id + "/changepassword", data);
  }
  static delete(id) {
    return _delete("kpi/realisation/" + id);
  }
  static check_token(data) {
    return _post("auth/checktoken/", data);
  }
  static getGroups() {
    return _get("kpi/realisation/groups/");
  }
}
